import { render, staticRenderFns } from "./AssignDistributor.vue?vue&type=template&id=72ad0dbc&"
import script from "./AssignDistributor.vue?vue&type=script&lang=js&"
export * from "./AssignDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports